import {AnyFn} from '../common/functions/AnyFn';

export function isFunction(o?: any): o is AnyFn {
    return typeof o === 'function';
}